import { type MCPServerInfo } from '../../types';

const SourcebotServer: MCPServerInfo = {
  serverId: 'SOURCEBOT',
  name: 'Sourcebot',
  slug: 'sourcebot',
  description:
    'Search source code, browse repositories, read files, and query commit history across your self-hosted Sourcebot instance.',
  source: {
    sourceType: 'DYNAMIC_REMOTE_URL',
    mcpServerUrl: 'https://{sourcebotBaseUrl}/api/mcp',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: ['sourcebotBaseUrl'],
    properties: {
      sourcebotBaseUrl: {
        type: 'string',
        description:
          'Sourcebot instance host (e.g. sourcebot.example.com) — no protocol or path',
        sensitive: false,
        isUrlParameter: true
      }
    }
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default SourcebotServer;
